import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { QRTagBagWiseReportListing } from './Pages';

export const QRTagBagWiseReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={QRTagBagWiseReportListing} />
    </Fragment>
)